import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { VatRate } from "~/providers/general-provider";

interface VatRateStoreState {
  selectedVatRate?: VatRate;
  setSelectedVatRate: (vatRate?: VatRate) => void;
  vatRateFormOpen: boolean;
  setVatRateFormOpen: (open: boolean) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

export const useVatRateStore = create<VatRateStoreState>()(
  devtools((set) => ({
    isLoading: false,
    vatRateFormOpen: false,
    setIsLoading: (isLoading) => {
      set(() => ({ isLoading }));
    },
    setVatRateFormOpen: (open) => {
      set(() => ({ vatRateFormOpen: open }));
    },
    setSelectedVatRate: (vatRate) => {
      set(() => ({ selectedVatRate: vatRate }));
    },
  })),
);
